
class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange.bind(this));
  }
  onStickyVariantChange() {
    const sel = this.querySelector("select");
    if (!sel) return;
    const form = document.querySelector(`#product-sticky-form-${this.dataset.section}`);
    if (!form) return;

    // hidden id update
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = sel.value;

    // price update from option[data-price]
    const opt = sel.options[sel.selectedIndex];
    const priceP = document.querySelector(".product__sticky .sticky__proudct_title p");
    if (priceP && opt && opt.dataset.price) priceP.textContent = opt.dataset.price;
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

// initial sync (id + price)
(() => {
  const sel = document.querySelector("#sticky__variant");
  if (!sel) return;

  const idInput = document.querySelector("#sticky__selected_variant_id");
  if (idInput) idInput.value = sel.value;

  const opt = sel.options[sel.selectedIndex];
  const priceP = document.querySelector(".product__sticky .sticky__proudct_title p");
  if (priceP && opt && opt.dataset.price) priceP.textContent = opt.dataset.price;
})();

// helper
function TopOffset(el){ if(!el) return {top:0}; const r = el.getBoundingClientRect(); return { top: r.top + window.scrollY }; }

// sticky show/hide on scroll
(() => {
  const buyForm = document.querySelector(".product_buy_button_form");
  const stickyWrap = document.querySelector(".product__sticky");
  if (!buyForm || !stickyWrap) return;

  const onScroll = () => {
    const t = TopOffset(buyForm).top;
    if (window.scrollY > t) {
      stickyWrap.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      stickyWrap.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
})();

